import clsx from "clsx";
import { useMemo, useState, useEffect } from "react";
import BurgerMenu from "../BurgerMenu";
import SearchBar from "../SearchBar";
import TabBar from "../TabBar";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as CloseIcon } from "../assets/close.svg";
import style from "./style.module.scss";
import TopCategoryMenu from "./TopCategoryMenu";

function MenuMobile({
  home,
  logo,
  langs,
  searchPageLink,
  categories,
  productSection,
  socials,
  contactLink,
  categoriesLink,
  storeLocatorPage,
  topCategoryMenu,
}) {
  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const isHomePage = window.location.pathname === "/";

  const allTerms = useMemo(
    () =>
      categories
        ? Object.values(categories).concat(productSection)
        : productSection,
    [categories, productSection]
  );

  const openSearchMenu = () => {
    setSearchOpen(true);
    closeBurgerMenu();
    document.getElementById("page").classList.add("dark-overlay");
  };

  const closeSearchMenu = () => {
    setSearchOpen(false);
    document.getElementById("page").classList.remove("dark-overlay");
  };

  const openBurgerMenu = () => {
    setBurgerMenuOpen(true);
    closeSearchMenu();
    document.getElementById("page").classList.add("dark-overlay");
  };

  const closeBurgerMenu = () => {
    setBurgerMenuOpen(false);
    document.getElementById("page").classList.remove("dark-overlay");
  };

  useEffect(() => {
    if (searchOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [searchOpen]);

  return (
    <div className={style.menuMobile}>
      <div className={style.top}>
        <div className={style.content}>
          <div className={style.toggleMenuBtn}>
            {burgerMenuOpen && (
              <CloseIcon
                className={style.closeIcon}
                onClick={closeBurgerMenu}
              />
            )}
          </div>
          <a href={home}>
            {logo?.url ? (
              <img
                src={logo.url}
                alt={logo.alt || logo.title}
                className={style.logo}
                loading="lazy"
              />
            ) : (
              <Logo className={style.logo} />
            )}
          </a>
          <div className={style.toggleSearchBtn}>
            {searchOpen && (
              <CloseIcon
                className={style.closeIcon}
                onClick={closeSearchMenu}
              />
            )}
          </div>
        </div>
      </div>
      {topCategoryMenu && isHomePage && !burgerMenuOpen && (
        <TopCategoryMenu topCategoryMenu={topCategoryMenu} />
      )}
      <div className={clsx(style.searchBarContainer, searchOpen && style.open)}>
        <SearchBar
          searchPageLink={searchPageLink}
          hasTopCategoryMenu={
            topCategoryMenu && isHomePage && !burgerMenuOpen ? true : false
          }
          searchOpen={searchOpen}
        />
      </div>
      <BurgerMenu
        burgerMenuOpen={burgerMenuOpen}
        socials={socials}
        categories={allTerms}
        contactLink={contactLink}
        categoriesLink={categoriesLink}
        langs={langs}
      />
      <TabBar
        storeLocatorPage={storeLocatorPage}
        searchOpen={searchOpen}
        openSearchMenu={openSearchMenu}
        closeSearchMenu={closeSearchMenu}
        burgerMenuOpen={burgerMenuOpen}
        openBurgerMenu={openBurgerMenu}
        closeBurgerMenu={closeBurgerMenu}
      />
    </div>
  );
}

export default MenuMobile;
